'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@heroui/react';
import { LucideMenu } from 'lucide-react';
import Link from 'next/link';
import { LightClubeLogo } from '@/components/svgs/club-pormade-logo';
import { APP_ROUTES } from '@/shared/constants/app-routes';
import { buildAppRoute } from '@/shared/functions/build-app-route';
export default function LandingPageNavbar() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex w-full select-none items-center gap-2"><LightClubeLogo width={150} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Button as={Link} radius="md" variant="light" href={buildAppRoute(APP_ROUTES.EXTERNAL.ENTERPRISE.WHO_WE_ARE)}>A Pormade</Button>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button as={Link} radius="md" href={buildAppRoute(APP_ROUTES.PUBLIC.REGISTER)} className="bg-clube-black text-white" variant="solid">Inscreva-se</Button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="hidden w-full gap-4 items-center justify-end sm:flex">{t1}{t2}<Button as={Link} radius="md" href={buildAppRoute(APP_ROUTES.PUBLIC.LOGIN)} className="bg-clube-black text-white" variant="solid">Entrar</Button></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DropdownTrigger><Button variant="light" isIconOnly={true} className="flex sm:hidden"><LucideMenu size={32} /></Button></DropdownTrigger>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DropdownItem as={Link} key="home" href={buildAppRoute(APP_ROUTES.EXTERNAL.ENTERPRISE.WHO_WE_ARE)}>A Pormade</DropdownItem>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DropdownItem as={Link} key="register" className="bg-clube-black text-white" variant="solid" href={buildAppRoute(APP_ROUTES.PUBLIC.REGISTER)}>Inscreva-se</DropdownItem>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <nav className="sticky top-0 z-50 flex h-24 w-full items-center justify-between bg-background p-6 backdrop-blur-md">{t0}{t3}<Dropdown className="bg-background">{t4}<DropdownMenu aria-label="Static Actions">{t5}{t6}<DropdownItem as={Link} key="enter" className="bg-clube-black text-white" variant="solid" href={buildAppRoute(APP_ROUTES.PUBLIC.LOGIN)}>Entrar</DropdownItem></DropdownMenu></Dropdown></nav>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}